import { registerPlugin } from '@capacitor/core';
const ImagePicker = registerPlugin('ImagePicker', {});
export * from './definitions';
export { ImagePicker };
//# sourceMappingURL=index.js.map